export default "__VITE_ASSET__6e651623__"